module.exports = __webpack_public_path__ + "media/header-video.3fd44526.mp4";